/**
 * Filtros para colunas do Board (ex.: ocultar técnicos sem OS).
 */

/** Pendente ainda pode coexistir com grupo de status — não soma no total (evita double-count). */
const BOARD_CONDT_PENDENTE_KEY = 'PENDENTE';
/** Liberado exclusivo: conta no total da coluna (inbox). */
const BOARD_CONDT_LIBERADO_KEY = 'LIBERADO';

function collectOrderIdsFromTechData(data) {
  const ids = new Set();
  if (!data || typeof data !== 'object') return ids;
  for (const [key, arr] of Object.entries(data)) {
    if (key === BOARD_CONDT_PENDENTE_KEY) continue;
    if (!Array.isArray(arr)) continue;
    for (const item of arr) {
      if (item == null) continue;
      if (typeof item === 'string' || typeof item === 'number') {
        const s = String(item).trim();
        if (s) ids.add(s);
        continue;
      }
      const raw = item.id ?? item.TB02115_CODIGO;
      if (raw != null && String(raw).trim() !== '') ids.add(String(raw).trim());
    }
  }
  return ids;
}

/**
 * Retorna o total de ordens de um técnico (ids únicos; inclui LIBERADO, exclui PENDENTE).
 * @param {object} technicianGroups - Mapa técnico -> { groupName -> ordem[] }
 * @param {string} technicianName
 * @returns {number}
 */
export function getTechnicianOrderCount(technicianGroups, technicianName) {
  if (!technicianGroups || !technicianName) return 0;
  const data = technicianGroups[technicianName];
  if (!data) return 0;
  return collectOrderIdsFromTechData(data).size;
}

/**
 * Retorna apenas os técnicos que possuem ao menos uma ordem de serviço.
 * @param {string[]} columnOrder - Lista de nomes de técnicos (ordem das colunas)
 * @param {object} technicianGroups - Mapa técnico -> { groupName -> ordem[] }
 * @returns {string[]}
 */
export function filterTechnicianColumnsByHasOrders(columnOrder, technicianGroups) {
  if (!columnOrder || !Array.isArray(columnOrder)) return [];
  if (!technicianGroups || typeof technicianGroups !== 'object') return columnOrder;
  return columnOrder.filter((tech) => collectOrderIdsFromTechData(technicianGroups[tech]).size > 0);
}

const FUTURA_GROUP = 'FUTURA';

function orderScheduleInRange(ordem, startDate, endDate) {
  if (!ordem || !ordem.schedule) return false;
  let dateStr = null;
  if (typeof ordem.schedule === 'string' && /^\d{4}-\d{2}-\d{2}/.test(ordem.schedule)) {
    dateStr = ordem.schedule.split('T')[0];
  } else {
    try {
      const scheduleDate = new Date(ordem.schedule);
      dateStr = `${scheduleDate.getUTCFullYear()}-${String(scheduleDate.getUTCMonth() + 1).padStart(2, '0')}-${String(scheduleDate.getUTCDate()).padStart(2, '0')}`;
    } catch (e) {
      return false;
    }
  }
  return dateStr >= startDate && dateStr <= endDate;
}

/**
 * Retorna apenas os técnicos que possuem ao menos uma OS na seção FUTURA dentro do período filtrado (OS futura).
 * Usado quando o filtro "OS futura" com período está ativo nas colunas de técnicos.
 * @param {string[]} columnOrder - Lista de nomes de técnicos (ordem das colunas)
 * @param {object} technicianGroups - Mapa técnico -> { groupName -> ordem[] }
 * @param {{ startDate: string, endDate: string } | null} osFuturaRange - Período no formato YYYY-MM-DD
 * @returns {string[]}
 */
export function filterTechnicianColumnsByFuturaRange(columnOrder, technicianGroups, osFuturaRange) {
  if (!columnOrder || !Array.isArray(columnOrder)) return columnOrder;
  if (!osFuturaRange || !osFuturaRange.startDate || !osFuturaRange.endDate) return columnOrder;
  if (!technicianGroups || typeof technicianGroups !== 'object') return columnOrder;
  const { startDate, endDate } = osFuturaRange;
  return columnOrder.filter((tech) => {
    const data = technicianGroups[tech];
    if (!data) return false;
    const futuraOrders = data[FUTURA_GROUP];
    if (!Array.isArray(futuraOrders) || futuraOrders.length === 0) return false;
    return futuraOrders.some((ordem) => orderScheduleInRange(ordem, startDate, endDate));
  });
}

export { BOARD_CONDT_LIBERADO_KEY, BOARD_CONDT_PENDENTE_KEY };
